import { Tab, TabItem } from '@commonComponents/formComponents/Tab'
import React from 'react'
import EdiResponse from './response/EdiResponse'
import JsonResponse from './response/JsonResponse'

const DetailedResponse = (props) => {
    const { responseId } = props

    return (

        <div className='ccs-air_response'>
            <Tab>
                <TabItem id='edi' title='EDI'>
                    <EdiResponse responseId={responseId} />
                </TabItem>
                <TabItem id='edi' title='JSON'>
                    <JsonResponse responseId={responseId} />
                </TabItem>
            </Tab>
        </div>
    )
}

export default DetailedResponse